import { captureException, captureMessage } from 'shared/sentryClient';

export { captureException, captureMessage };
